module.exports = __webpack_public_path__ + "fonts/Roboto-500.d0884059.ttf";